import { useForm } from '../../context/FormContext'
import FormField from '../ui/FormField'
import Select from '../ui/Select'
import FileUpload from '../ui/FileUpload'
import ar from '../../locales/ar.json'

const t  = ar.step3
const ta = ar.app

const INCIDENT_OPTIONS = Object.entries(t.incidentTypes).map(([k, v]) => ({ value: v, label: v }))
const EVIDENCE_TYPES   = Object.keys(t.evidenceTypes)

function YesNoSelect({ id, label, value, onChange, error }) {
  return (
    <Select
      id={id} label={label} value={value} onChange={onChange} error={error}
      options={[{ value: 'نعم', label: 'نعم' }, { value: 'لا', label: 'لا' }]}
      placeholder={ta.select}
    />
  )
}

function ConditionalFields({ incidentType, incidentDetails, updateDetail, errors }) {
  const f = (id) => ({ id: `detail_${id}`, error: errors[`detail_${id}`] })
  const val = (k) => incidentDetails[k] || ''
  const set = (k) => (v) => updateDetail(k, v)

  const inp = (fieldKey, label, placeholder, required = false, type = 'text') => (
    <FormField key={fieldKey} id={`detail_${fieldKey}`} label={label} required={required} error={errors[`inc_${fieldKey}`]}>
      <input
        id={`detail_${fieldKey}`}
        type={type}
        value={val(fieldKey)}
        onChange={(e) => set(fieldKey)(e.target.value)}
        className="input-base"
        placeholder={placeholder}
        dir="rtl"
      />
    </FormField>
  )

  switch (incidentType) {
    case 'معتقل لدى النظام':
      return (
        <div className="mt-4 p-4 bg-stone-50 rounded-xl border border-stone-200 space-y-0">
          <h3 className="text-sm font-semibold text-stone-700 mb-3">{t.arrestSection}</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {inp('arrest_date', t.arrest_date, 'مثال: 2013-03-15', false, 'text')}
            {inp('arrest_place', t.arrest_place, 'مثال: حاجز الشام')}
          </div>
          <YesNoSelect id="rcvd_notif" label={t.received_death_notification}
            value={val('received_death_notification')} onChange={set('received_death_notification')} />
          {val('received_death_notification') === 'نعم' &&
            inp('death_notification_date', t.death_notification_date, 'مثال: 2015-07')}
        </div>
      )

    case 'اختفى أثناء المظاهرات':
      return (
        <div className="mt-4 p-4 bg-stone-50 rounded-xl border border-stone-200 space-y-0">
          <h3 className="text-sm font-semibold text-stone-700 mb-3">{t.demonstrationSection}</h3>
          {inp('demonstration_name', t.demonstration_name, 'مثال: مظاهرة جمعة لا للحل الأمني')}
          {inp('disappearance_date', t.disappearance_date, 'مثال: 2011-07-29')}
          <Select id="disp_killed" label={t.disappeared_or_killed}
            value={val('disappeared_or_killed')} onChange={set('disappeared_or_killed')}
            options={[{ value: 'استشهد بالمكان', label: t.died_at_location }, { value: 'فُقد أثره', label: t.lost_trace }]}
            placeholder={ta.select} />
        </div>
      )

    case 'استشهد في الجبهة/مع الثوار':
      return (
        <div className="mt-4 p-4 bg-stone-50 rounded-xl border border-stone-200 space-y-0">
          <h3 className="text-sm font-semibold text-stone-700 mb-3">{t.battlefieldSection}</h3>
          {inp('faction_name', t.faction_name, 'اسم الفصيل')}
          {inp('battlefield_location', t.battlefield_location, 'مثال: جبهة منين — دمشق')}
          <YesNoSelect id="body_ret" label={t.body_returned}
            value={val('body_returned')} onChange={set('body_returned')} />
          {val('body_returned') === 'نعم' && inp('burial_place', t.burial_place, 'مكان الدفن')}
        </div>
      )

    case 'فُقد على حاجز':
      return (
        <div className="mt-4 p-4 bg-stone-50 rounded-xl border border-stone-200 space-y-0">
          <h3 className="text-sm font-semibold text-stone-700 mb-3">{t.checkpointSection}</h3>
          {inp('checkpoint_name', t.checkpoint_name, 'اسم أو موقع الحاجز')}
          {inp('controlling_party', t.controlling_party, 'الجهة المسيطرة')}
        </div>
      )

    case 'فُقد أثناء اقتحام/مجزرة':
      return (
        <div className="mt-4 p-4 bg-stone-50 rounded-xl border border-stone-200 space-y-0">
          <h3 className="text-sm font-semibold text-stone-700 mb-3">{t.massacreSection}</h3>
          {inp('event_name', t.event_name, 'مثال: مجزرة داريا')}
          {inp('event_date', t.event_date, 'مثال: 2012-08-25')}
        </div>
      )

    case 'استشهد بقصف/قذيفة':
      return (
        <div className="mt-4 p-4 bg-stone-50 rounded-xl border border-stone-200 space-y-0">
          <h3 className="text-sm font-semibold text-stone-700 mb-3">{t.bombingSection}</h3>
          {inp('strike_date', t.strike_date, 'مثال: 2018-04-07')}
          {inp('strike_location', t.strike_location, 'مثال: دوما — الغوطة الشرقية')}
        </div>
      )

    default:
      // "أخرى" or other civilian incidents
      if (incidentType) {
        return (
          <div className="mt-4 p-4 bg-stone-50 rounded-xl border border-stone-200">
            <FormField id="incident_other" label={t.incident_other_details}>
              <textarea
                id="incident_other"
                value={val('incident_other_details')}
                onChange={(e) => set('incident_other_details')(e.target.value)}
                className="input-base min-h-[100px]"
                rows={4}
                dir="rtl"
              />
            </FormField>
          </div>
        )
      }
      return null
  }
}

export default function Step3_Incident() {
  const { state, updateField, updateIncidentDetail, toggleArrayValue, addEvidenceFiles, removeEvidenceFile } = useForm()
  const { formData, files, errors } = state

  return (
    <div>
      <h2 className="section-title">
        <span className="bg-primary-700 text-white w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">٣</span>
        {t.sectionTitle}
      </h2>

      {/* Incident type */}
      <Select
        id="incident_type"
        label={t.incident_type}
        required
        value={formData.incident_type}
        onChange={(v) => updateField('incident_type', v)}
        options={INCIDENT_OPTIONS}
        placeholder={ta.select}
        error={errors.incident_type}
      />

      {/* Conditional detail fields */}
      <ConditionalFields
        incidentType={formData.incident_type}
        incidentDetails={formData.incidentDetails}
        updateDetail={updateIncidentDetail}
        errors={errors}
      />

      {/* Evidence types (checkboxes) */}
      <div className="mt-6 pt-4 border-t border-stone-100">
        <h3 className="text-base font-semibold text-primary-700 mb-3">{t.evidenceSection}</h3>
        <div className="mb-4">
          <label className="label-base">{t.evidence_types}</label>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-1">
            {EVIDENCE_TYPES.map((et) => (
              <label key={et} className="flex items-center gap-2 cursor-pointer p-2 rounded-lg hover:bg-stone-50 border border-transparent hover:border-stone-200 transition-colors">
                <input
                  type="checkbox"
                  checked={formData.evidence_types.includes(et)}
                  onChange={() => toggleArrayValue('evidence_types', et)}
                  className="w-4 h-4 text-primary-700 rounded border-stone-300"
                />
                <span className="text-sm text-stone-700">{et}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Evidence file upload */}
        <FileUpload
          id="evidence_upload"
          label={t.evidence_upload}
          accept="image/jpeg,image/png,application/pdf,video/mp4"
          multiple
          files={files.evidence_upload}
          onAdd={addEvidenceFiles}
          onRemove={removeEvidenceFile}
          hint={t.evidence_upload_hint}
          error={errors.evidence_upload}
        />
      </div>
    </div>
  )
}
